
import { defineComponent, ref } from "vue";
import { menulist, menumodifyState, Addmenu, Edmenu } from "@/api/Menuconfiguration";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const tableData = ref<any>();
    const tableColumn = ref([
      {
        prop: "menuName",
        label: "菜单名称",
      },
      {
        slotName: "accounttype",
      },
      {
        slotName: "Sort",
      },

      {
        slotName: "slotName",
      },
    ]);
    const SearchClass = () => {
      getzhtTable();
    };
    const zhtText = ref<any>();
    const zhtData = ref<any>({
      menuParentId: route.query.id,
    });
    const menName = ref("");
    const getzhtTable = () => {
      menulist(route.query.id, menName.value).then((res) => {
        console.log(res);
        tableData.value = res.data.list;
      });
      //   menuParentId
    };
    getzhtTable();

    const textTitle = ref<any>();
    const GooldData = ref<any>({
      command: "",
      merchantId: 0,
      resourceNo: 0,
    });
    // 主后台推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: any) => {
      console.log(row);
      GooldData.value.merchantId = row.merchantId;
      GooldData.value.resourceNo = row.resourceNo;
      zhtText.value = "启用推送后，商户端将自动接收该分类数据，并且不可逆，确认要继续吗";

      pushDisplay.value = true;
    };
    const zhtpushDisplay = () => {
      pushDisplay.value = false;
      getzhtTable();
    };
    const zhtClick = () => {
      pushDisplay.value = false;
      gooleshow.value = true;
    };
    // 谷歌
    const gooleshow = ref(false);
    // 谷歌确认
    const onconfirm = (val: any) => {
      console.log(val.ruleForm.gooleId);
      GooldData.value.command = val.ruleForm.gooleId;
      Edmenu(GooldData.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          gooleshow.value = false;
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
          gooleshow.value = false;
        }
      });
    };

    // 排序
    const zhtinputnumber = (row: any) => {
      console.log(row);
      Edmenu({ id: row.id, menuName: row.menuName, menuParentId: row.menuParentId, menuSort: row.menuSort, menuType: row.menuType }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
        }
      });
    };
    // 主后台菜单编辑添加
    const FromData = ref<any>({
      menuParentId: Number(route.query.id),
      menuName: "",
      menuSort: 1,
      menuType: "DIRECTORY",
      menuUrl: "",
      id: "",
    });
    const EditmenuDisplay = ref<boolean>(false);
    const edit = (row: any) => {
      console.log(row);
      textTitle.value = "编辑";
      EditmenuDisplay.value = true;
      FromData.value.menuName = row.menuName;
      FromData.value.menuParentId = row.menuParentId;
      FromData.value.menuUrl = row.menuUrl;
      FromData.value.id = row.id;
      AddEd.value = "Ed";
    };
    // 编辑确认 +  添加二级菜单
    const saveEdit = () => {
      if (AddEd.value == "add") {
        Addmenu(FromData.value).then((res) => {
          if (res.code == 1) {
            ElMessage.success(res.msg as string);
            getzhtTable();
            EditmenuDisplay.value = false;
          } else {
            ElMessage.error(res.msg as string);
          }
        });
      } else {
        Edmenu(FromData.value).then((res) => {
          if (res.code == 1) {
            ElMessage.success(res.msg as string);
            getzhtTable();
            EditmenuDisplay.value = false;
          } else {
            ElMessage.error(res.msg as string);
          }
        });
      }
    };

    const AddEd = ref<any>();
    // 添加二级菜单
    const addSelectone = () => {
      textTitle.value = "添加二级菜单";
      EditmenuDisplay.value = true;
      FromData.value.menuUrl = "";
      FromData.value.menuName = "";
      AddEd.value = "add";
    };
    const imageUrl = ref("");
    const delectImg = (val: string) => {
      imageUrl.value = val;
    };
    const changeImg = (val: any) => {
      console.log(val, "上传图片");
      imageUrl.value = val.fileUrl;
    };
    //跳转二级
    const goTow = (row: any) => {
      console.log(row);
      router.push({ path: "/Merchantmenu/md/towthree", query: { id: row.id } });
    };
    return {
      tableData,
      tableColumn,
      switchFn,
      pushDisplay,
      EditmenuDisplay,
      edit,
      FromData,
      zhtData,
      SearchClass,
      zhtpushDisplay,
      textTitle,
      zhtText,
      zhtinputnumber,
      saveEdit,
      addSelectone,
      goTow,
      zhtClick,
      onconfirm,
      gooleshow,
      delectImg,
      changeImg,
      imageUrl,
    };
  },
});
